import SalesOrderView from './SalesOrderView';

export default SalesOrderView;
